<template>
  <v-container v-if="$store.state.isUserLoggedIn" fill-height class="pa-0" style="overflow: hidden;">
    <v-row no-gutters>
      <v-col>
        <v-card tile :height="mainPanelHeight - 120">
          <v-toolbar height="30" class="pa-0 opposite--text" dense flat color="primary">
            <span class="mr-2 font-weight-bold text-h6">/</span>
            <span v-if="userData.academyName">{{ userData.academyName }}</span>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text class="pa-1">
            <v-row dense>
              <v-col cols="8">
                <v-card flat v-if="!userData.loading">
                  <v-card-actions class="text-caption">
                    <span></span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <div v-if="!userData.academyName">
                    <v-btn @click="navigateTo({ name: 'editprofile', query: { d: 'academy' } })" small block
                      color="secondary" elevation="0">
                      {{ $t("message.add_academy") }}
                    </v-btn>
                    <div class="text-center tex-caption">
                      {{ $t("message.add_academy_explained") }}
                    </div>
                  </div>
                  <div v-else>
                    <div style="height:65px">
                      <v-list-item dense @click="goToAcademy(userData.academyId)">
                        <v-list-item-avatar class="pl-1 ml-1 pa-0">
                          <ImageDisplay v-if="userData.academyImage" size="30" :src="userData.academyImage">
                          </ImageDisplay>
                          <page-avatar v-else :src="userData.academyImage" size="30" object="academy"
                            :country="userData.academyCountry" />
                        </v-list-item-avatar>
                        <v-list-item-content class="pt-0 pb-0 mb-0 mt-0">
                          <v-list-item-title>{{ userData.academyAddress }}</v-list-item-title>
                          <v-list-item-subtitle>{{ userData.academyCity }}</v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </div>
                    <div @click="goToAcademy(userData.academyId, null, true)"
                      v-if="userData.academyId && !userData.claimedAcademy" class="text-caption">
                      <v-icon size="15" class="mr-1">mdi-alert-box-outline</v-icon>
                      {{ $t("message.claim_academy_pitch") }}
                    </div>
                  </div>
                </v-card>
                <v-card-text v-else>
                  <v-skeleton-loader tile type="image"></v-skeleton-loader>
                </v-card-text>
              </v-col>
              <v-col cols="4">
                <v-card flat>
                  <v-card-actions class="text-caption">
                    <span></span>
                    <v-spacer></v-spacer>
                  </v-card-actions>
                  <v-btn @click="navigateTo({ name: 'viewposts', params: { feed: 'world' } })" outlined small block
                    color="primary" elevation="0">
                    {{ $t("message.community") }}
                    <v-spacer></v-spacer>
                  </v-btn>
                  <v-btn elevation="0" v-if="!userData.masterId"
                    @click="navigateTo({ name: 'editprofile', query: { d: 'lineage' } })" small block color="secondary"
                    class="mt-1">
                    {{ $t("message.add_lineage") }}
                    <v-spacer></v-spacer>
                  </v-btn>
                  <v-btn v-else @click="navigateTo({ name: 'lineagetree', query: { n: userData.masterId } })" outlined
                    small block color="primary" class="mt-1">
                    {{ $t("message.lineage") }}
                    <v-spacer></v-spacer>
                  </v-btn>
                  <v-btn elevation="0" v-if="userData.historyCount > 0" @click="navigateTo({ name: 'edithistory' })"
                    outlined small block color="primary" class="mt-1">
                    {{ $t("message.history") }}
                    <v-spacer></v-spacer>
                  </v-btn>
                  <v-btn elevation="0" v-else @click="navigateTo({ name: 'edithistory' })" small block color="secondary"
                    class="mt-1">
                    {{ $t("message.history") }}
                    <v-spacer></v-spacer>
                  </v-btn>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col>
        <v-card tile :height="mainPanelHeight + 10">
          <v-toolbar @click="navigateTo({ name: 'viewmytrainingtab', params: { tabId: 0 } })" height="30"
            class="pa-0 opposite--text" dense flat color="primary">
            <span class="mr-2 font-weight-bold text-h6">/</span>
            {{ $t("message.my_training") }}
          </v-toolbar>
          <div v-if="myTrainingData.loading">
            <v-skeleton-loader tile :height="mainPanelHeight - 30" type="image"></v-skeleton-loader>
          </div>
          <div v-else>
            <v-row>
              <v-col cols="4" class="pr-0 pb-0">
                <v-card flat class="mt-3" @click="navigateTo({ name: 'viewmytrainingtab', params: { tabId: 100 } })">
                  <div class="font-weight-bold pl-2">
                    <div>{{ $t("message.this_week").toUpperCase() }}</div>
                    <div>
                      <div class="text-h4">
                        {{ myTrainingData.currentWeekData.thisWeekMinutes ?
                          myTrainingData.currentWeekData.thisWeekMinutes : 0 }}
                        <span class="text-caption"
                          v-if="!isNaN(myTrainingData.currentWeekData.deltaPercent) && myTrainingData.currentWeekData.deltaPercent != 0">
                          <v-icon color="error"
                            v-if="myTrainingData.currentWeekData.deltaPercent < 0">mdi-chevron-double-down</v-icon>
                          <v-icon v-else color="success">mdi-chevron-double-up</v-icon>{{
                            Math.abs(myTrainingData.currentWeekData.deltaPercent) }}%
                        </span>
                      </div>
                      <div class="text-caption text-truncate">{{ $t("message.minutes_trained").toUpperCase() }}</div>
                    </div>
                  </div>
                </v-card>
                <v-card flat class="mt-3 gray--text">
                  <div class="font-weight-bold pl-2">
                    <div>{{ $t("message.last_week").toUpperCase() }}</div>
                    <div>
                      <div class="text-h4">{{ myTrainingData.currentWeekData.lastWeekMinutes ?
                        myTrainingData.currentWeekData.lastWeekMinutes : 0 }}</div>
                      <div class="text-caption text-truncate">{{ $t("message.minutes_trained").toUpperCase() }}</div>
                    </div>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="8" class="pb-0">
                <ApexChart v-if="myTrainingData.trendline" type="line" height="200"
                  :options="myTrainingData.trendline.options" :series="myTrainingData.trendline.series">
                </ApexChart>
                <v-card-text v-else class="text-center">
                  <p>{{ $t("message.no_minutes_recorded") }}</p>
                  <p>{{ $t("message.no_minutes_recorded2") }}</p>
                </v-card-text>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-btn @click="navigateTo({ name: 'viewmytrainingtab', params: { tabId: 1 } })" small text><v-icon
                  class="mr-1">mdi-book-open-variant-outline</v-icon>{{ $t("message.journal")
                  }}</v-btn>
              <v-spacer></v-spacer>
              <v-btn @click="pointsDialog = true;" small text><span class="mr-1 font-weight-bold">{{ points.total
                  }}</span>{{
                    $t("message.points")
                  }}</v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row no-gutters>
      <v-col cols="6">
        <v-card tile flat :min-height="lowerPanelsHeight" @click="go2MatchTracker">
          <v-toolbar height="30" class="pa-0 opposite--text" dense flat color="primary">
            <span class="mr-2 font-weight-bold text-h6">/</span>
            {{ $t("message.match_tracker") }}
          </v-toolbar>
          <div v-if="matchTrackerData.loading">
            <v-skeleton-loader class="mx-auto" type="image"></v-skeleton-loader>
          </div>
          <div v-else>
            <v-list dense>
              <v-list-item dense>
                <v-list-item-content class="pt-0 pb-0 mb-0 mt-0">
                  <v-list-item-title>{{ $t("message.saved") }}</v-list-item-title>
                  <v-list-item-title>{{ $t("message.competitors") }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="pl-1 ml-1 pa-0">
                  <v-btn x-small elevation="0" fab>
                    {{ matchTrackerData.savedCompetitorsCount }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-content class="pt-0 pb-0 mb-0 mt-0">
                  <v-list-item-title>{{ $t("message.active") }}</v-list-item-title>
                  <v-list-item-title>{{ $t("message.competing") }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="pl-1 ml-1 pa-0 mb-0 mt-0">
                  <v-btn x-small elevation="0" fab>
                    {{ matchTrackerData.savedCompetitorsCompetingCount }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
              <v-list-item dense>
                <v-list-item-content class="pt-0 pb-0 mb-0 mt-0">
                  <v-list-item-title>{{ $t("message.active") }}</v-list-item-title>
                  <v-list-item-title>{{ $t("message.events") }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-btn x-small elevation="0" fab>
                    {{ matchTrackerData.activeEventsCount }}
                  </v-btn>
                </v-list-item-action>
                <v-list-item-avatar size="30" class="pl-1 ml-1 pa-0" outlined>
                  <img :src="assets() + '/external-logos/ibjjf-logo-blue.png'" />
                </v-list-item-avatar>
              </v-list-item>
            </v-list>
            <v-card-actions class="pb-0 pt-0" style="margin-top:-2px">
              <v-btn elevation="0" @click="go2MatchTracker" block text small color="primary">
                <span class="mr-1">{{ $t("message.view_more") }}</span>
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card tile flat :min-height="lowerPanelsHeight">
          <v-toolbar height="30" class="pa-0 opposite--text" dense flat color="primary">
            <span class="mr-2 font-weight-bold text-h6">/</span>
            {{ $t("message.news") }}
          </v-toolbar>
          <div v-if="newsData.loading">
            <v-skeleton-loader class="mx-auto" type="image"></v-skeleton-loader>
          </div>
          <div v-else>
            <v-list dense>
              <template v-for="(i, index) in newsData.last3">
                <v-list-item @click="openRssLink(i)" :key="'home_news_' + index" dense class="pt-0 pb-0 mb-0 mt-0">
                  <v-list-item-content>
                    <v-list-item-title class="text-truncate" style="overflow: hidden;">
                      {{ truncate(i.title, 20) }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-truncate" style="overflow: hidden;">
                      {{ truncate(i.description, 20) }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-avatar tile class="pa-0" size="30">
                    <v-img
                      :src="`https://wsrv.nl/?url=${encodeURIComponent(i.image)}&default=https://via.placeholder.com/30`" />
                  </v-list-item-avatar>
                </v-list-item>
              </template>
            </v-list>
            <v-card-actions class="pb-0 pt-0">
              <v-btn elevation="0" @click="go2News" block text small color="primary">
                <span class="mr-1">{{ $t("message.new_today") }}</span>
                <span class="text-h6">{{ newsData.newToday }}</span>
              </v-btn>
            </v-card-actions>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="pointsDialog">
      <v-card outlined v-if="points.positions">
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn icon small @click="pointsDialog = false"><v-icon>mdi-close-circle</v-icon></v-btn>
        </v-card-actions>
        <v-card-title>{{ $t("message.points") }}</v-card-title>
        <v-list dense>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.total_points") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.total }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.last_30_days") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.last30Days }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.this_month") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.thisMonth }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.academy_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.positions.academyPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.city_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.positions.cityPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.country_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.positions.countryPosition }}
            </v-list-item-action>
          </v-list-item>
          <v-divider></v-divider>
          <v-list-item dense>
            <v-list-item-content>
              {{ $t("message.world_position") }}
            </v-list-item-content>
            <v-list-item-action>
              {{ points.positions.worldPosition }}
            </v-list-item-action>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-btn elevation="0" @click="navigateTo({ name: 'points' })" block>{{ $t("message.view_more") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import PageAvatar from "@/components/displays/CountryObjectAvatar.vue";
import ConnectService from "@/services/ConnectService";
import NewsService from "@/services/NewsService";
import NotificationService from "@/services/NotificationService";
import ApexChart from 'vue-apexcharts';

export default {
  name: 'HomeRegular',
  data() {
    return {
      mainPanelHeight: 280,
      lowerPanelsHeight: 240,
      pointsDialog: false,
      matchTrackerData: {
        loading: true,
        savedCompetitorsCount: 0,
        activeCompetingCount: 0,
        activeEventsCount: 0,
      },
      myTrainingData: {
        loading: true,
        last30Percent: 0,
        minutes: 0,
      },
      newsData: {
        loading: true,
      },
      bulletinData: {
        loading: true,
      },
      points: {
        loading: true,
      },
      userData: {
        loading: true,
      }
    };
  },
  components: {
    ApexChart,
    PageAvatar
  },
  created() {
    this.initMe();
  },
  mounted() {
    const vm = this;
    vm.getMessagesCount(function (countM) {
      vm.getNotificationsCount(function (countS) {
        vm.$store.dispatch("setMessagesCount", countM);
        vm.$store.dispatch("setNotifications", countS);
        if (countM + countS == 0) {
          NotificationService.clearMobile();
        }
      });
    });
  },
  methods: {
    openRssLink(item) {
      if (item) {
        const data = {
          entryId: item._id
        };
        if (item.feed)
          NewsService.recordClick(item.feed._id, data);
        this.goToLink(item.url)
      }
    },
    async initMe() {
      const me = await ConnectService.getMe(null, null, this.$store.state.userManagedAcademy);
      if (me) {
        this.hiddenUser = me.data.hidden;
        if (me.data.isManagedAcademyAdmin && !this.$store.state.managedAcademyAdmin) {
          this.$store.dispatch("setManagedAcademyAdmin", true);
        } else if (!me.data.isManagedAcademyAdmin) {
          this.$store.dispatch("setManagedAcademyAdmin", false);
        }
        const validManagedAcademyIds = (me.data.managedAcademies || []).map((a) => a._id);
        const currentManagedAcademy = this.$store.state.userManagedAcademy;
        if (me.data.isManagedAcademyMember && !(currentManagedAcademy && validManagedAcademyIds.includes(currentManagedAcademy))) {
          this.$store.dispatch("setUserManagedAcademy", me.data.mainManagedAcademy);
        } else if (!me.data.isManagedAcademyMember) {
          this.$store.dispatch("setUserManagedAcademy", null);
        }
        if (me.data.mainManagedAcademy) {
          this.managedAcademy = me.data.mainManagedAcademy;
          if (this.$store.state.version == 4) {
            this.navigateTo({ name: 'home-member' })
          }
        }
        if (me.data.academy) {
          this.userData.academyName = me.data.academy.name;
          this.userData.academyImage = me.data.academy.image;
          this.userData.academyAddress = me.data.academy.address;
          this.userData.claimedAcademy = me.data.academy.claimed;
          this.userData.academyId = me.data.academy._id;
          this.userData.academyCountry = me.data.academy.country;
          this.userData.academyCity = me.data.academy.cityDisplay;
        }
        this.userData.masterId = me.data.masterId;
        this.userData.historyCount = me.data.historyCount;
        this.userData.loading = false;
        this.loadData();
      }
    },
    go2MatchTracker() {
      if (this.hiddenUser)
        this.showAlert(
          "info",
          this.$t("message.social_disabled")
        );
      else
        this.navigateTo({ name: 'ibjjftournaments' })
    },
    go2News() {
      if (this.hiddenUser)
        this.showAlert(
          "info",
          this.$t("message.social_disabled")
        );
      else
        this.navigateTo({ name: 'news' })
    },
    getCurrentWeekOfMonthGrouped() {
      const today = new Date();
      const year = today.getFullYear();
      const month = today.getMonth(); // 0-indexed
      const startOfMonth = new Date(year, month, 1);

      const getWeekNumber = (date) => {
        const day = date.getDate();
        const adjustedStart = (startOfMonth.getDay() + 6) % 7; // Adjust so Monday is 0
        return Math.floor((day + adjustedStart - 1) / 7) + 1;
      };

      const currentWeek = getWeekNumber(today);

      // Calculate total weeks in month
      const endOfMonth = new Date(year, month + 1, 0);
      const totalDays = endOfMonth.getDate();
      const lastDate = new Date(year, month, totalDays);
      const totalWeeks = getWeekNumber(lastDate);

      if (totalWeeks === 5) {
        if (currentWeek <= 2) return 1 + 1;
        return currentWeek;
      }

      return currentWeek + 1;//we need 1-4 not 0-3
    },
    loadData() {
      ConnectService.getHomePostsAcademy()
        .then((data) => {
          if (data.success) {
            this.bulletinData = data.data;
          }
        });
      ConnectService.getHomeMatchTracker()
        .then((data) => {
          if (data.success) {
            this.matchTrackerData = data.data;
          }
        });
      ConnectService.getHomePoints()
        .then((data) => {
          this.points = data.points;
          this.points.positions = data.positions;
        });
      ConnectService.getHomeMyTraining()
        .then((data) => {
          if (data.success) {
            this.myTrainingData = data.data;
            if (data.data.currentMonthTrendline && data.data.currentMonthTrendline.length) {
              this.myTrainingData.currentWeekData = data.data.currentWeekData;
              const series = [
                {
                  name: this.$t("message.this_month"),
                  data: data.data.currentMonthTrendline.map((doc) => {
                    return doc.minutes;
                  }),
                },
                {
                  name: this.$t("message.last_month"),
                  data: data.data.previousMonthTrendline.map((doc) => {
                    return doc.minutes;
                  })
                },
              ];
              const vm = this;
              this.myTrainingData.trendline = {
                options: {
                  colors: [this.themeColor('error'), this.themeColor('gray')],
                  labels: [this.$t("message.this_month"), this.$t("message.last_month")],
                  xaxis: {
                    categories: [1, 2, 3, 4],
                    labels: {
                      show: true,
                    }
                  },
                  markers: {
                    size: 4
                  },
                  yaxis: {
                    title: {
                      show: false
                    },
                    labels: {
                      show: false,
                    }
                  },
                  dataLabels: {
                    enabled: false,
                  },
                  stroke: {
                    curve: 'smooth',
                    width: [3, 2],
                    dashArray: [0, 6]
                  },
                  theme: {
                    mode: this.isDarkTheme() ? 'dark' : 'light',
                  },
                  chart: {
                    toolbar: {
                      show: false
                    },
                    background: 'none'
                  },
                  legend: {
                    position: 'bottom'
                  },
                  grid: {
                    borderColor: this.themeColor('neutral'),
                    strokeDashArray: 3
                  },
                  tooltip: {
                    x: {
                      formatter: function (value) {
                        return vm.$t("message.week") + ': ' + value;
                      }
                    },
                  },
                  /*
                  annotations: {
                    xaxis: [
                      {
                        x: this.getCurrentWeekOfMonthGrouped(),
                        borderColor: this.themeColor('secondary'),
                      }
                    ]
                  }
                  */
                },
                series: series
              };
            }
          }
        });
      ConnectService.getHomeNews()
        .then((data) => {
          if (data.success) {
            if (data.data.news) {
              this.newsData = data.data;
              this.newsData.last3 = [data.data.news[0], data.data.news[1], data.data.news[2]];
            }
          }
        });
    }
  }
}
</script>
<style scoped></style>
